import React from "react";
import {
  Badge,
  Button,
  Card,
  Col,
  Container,
  Image,
  Row,
} from "react-bootstrap";
import { ArrowRight } from "react-bootstrap-icons";
import { GoArrowUpRight } from "react-icons/go";
import { OurworksContent } from "../../../Constants/content";
import { useNavigate } from "react-router-dom";
import { LuArrowUpRight } from "react-icons/lu";
import { secondaryColor, textDarkColor } from "../../../Constants/Colors";
import { FaApple } from "react-icons/fa";
import googlePlayIcon from "../../../Assets/Images/Works/Mahalakshmi/icons/icons8-google-play-16.png";
import mmsProject from "../../../Assets/Images/Works/Mahalakshmi/mms-project.png";
import chain from "../../../Assets/Images/Works/Mahalakshmi/icons/chain.png"

const Works = () => {
  const navigate = useNavigate();

  return (
    <Container>
      <div className="text-center my-2">
        <Button
          variant="primary"
          style={{
            backgroundColor: "#007bff",
            border: "none",
            borderRadius: "20px",
            padding: "5px 20px",
            fontSize: "14px",
          }}
        >
          Our Works
        </Button>

        <h2
          className="fw-bold mb-0 py-3"
          style={{
            background: "linear-gradient(to right, #0070c9, #004e92)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            lineHeight: "1.3",
          }}
        >
          Design That Solves Real Problems
        </h2>
        <Button
          style={{
            backgroundColor: secondaryColor,
            color: textDarkColor,
            border: "none",
            boxShadow: "0 4px 20px rgba(0, 157, 255, 0.3)",
          }}
          className="rounded-pill my-2 px-4"
        >
          interact with our experts <LuArrowUpRight className="fs-5" />
        </Button>
      </div>

      <Container className="my-4">
        <Row
          className="align-items-center justify-content-between"
          style={{
            backgroundImage: "linear-gradient(135deg, #014F6F, #0297D5)",
            borderRadius: "12px",
            border: "6px solid #ade2f9ff",
          }}
        >
          {/* Left Side Content */}
          <Col
            md={6}
            lg={5}
            className="d-flex flex-column gap-lg-3 gap-1 py-2 py-lg-0"
          >
            <h4 className=" fw-bold text-light">
              <Image width={20} height={20} src={chain} />
              &nbsp; Project Links
            </h4>
            <p className=" text-light">
              <strong>Website:</strong>{" "}
              <a
                href="https://mahalakshmidiagnostics.com"
                target="_blank"
                className="text-light"
                rel="noreferrer"
              >
                mahalakshmidiagnostics.com
              </a>
            </p>

            <p className="text-light">
              <strong>Mobile App:</strong> Available Now On
            </p>

            <div className="d-flex gap-3">
              <Button
                style={{
                  background: "linear-gradient(to top, #025191ff, #13abecff)",
                  color: "#fff",
                  fontSize: "12px",
                }}
                className="d-flex align-items-center gap-1 gap-md-2 rounded-3 px-2 px-md-3 "
              >
                <Image src={googlePlayIcon} /> Download Now
              </Button>
              <Button
                style={{
                  background: "linear-gradient(to top, #025191ff, #13abecff)",
                  color: "#fff",
                  fontSize: "12px",
                }}
                className="d-flex align-items-center gap-1 gap-md-2 rounded-3 px-2 px-md-3 "
              >
                <FaApple /> Download Now
              </Button>
            </div>

            <p className="text-light mb-0">
              Patient Portal: Secure Login For Test Booking, Report Access &
              Status Tracking
            </p>
          </Col>

          {/* Right Side Image */}
          <Col md={6} lg={7} className="p-0 m-0">
            <Image
              src={mmsProject}
              alt="Project Preview"
              className="rounded"
              fluid
            />
          </Col>
        </Row>
      </Container>

      {/* Cards */}
      <Row>
        <Col xl={10} className="mx-auto">
          <Row xs={1} md={1} xl={1} className="g-4">
            {OurworksContent.map((project, idx) => (
              <Col key={idx} onClick={() => navigate(project.url)}>
                <Card
                  className="h-100 custom-work-card rounded-4 shadow-sm overflow-hidden"
                  style={{
                    background: project.gradient,
                    border: "2px solid rgb(114, 113, 113)",
                  }}
                >
                  {/* Show image first on small screens, second on md+ */}
                  <div className="d-md-none">
                    <Card.Img
                      src={project.image}
                      alt={project.title}
                      className="img-fluid rounded-top-4"
                      style={{
                        width: "100%",
                        height: "auto",
                        objectFit: "cover",
                      }}
                    />
                  </div>

                  <Row>
                    <Col
                      xs={12}
                      className="p-4 pb-0 d-flex justify-content-between align-items-center"
                    >
                      <Badge
                        bg="light"
                        text="dark"
                        className="px-3 py-2 rounded-pill fw-semibold"
                      >
                        Development Project
                      </Badge>
                      <div
                        className="rounded-circle d-flex align-items-center justify-content-center"
                        style={{
                          backgroundColor: "#fff",
                          width: "36px",
                          height: "36px",
                          boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                        }}
                      >
                        <GoArrowUpRight size={23} />
                      </div>
                    </Col>
                  </Row>

                  <Row className="g-0 align-items-center">
                    {/* Content Column */}
                    <Col
                      md={7}
                      className="p-4 d-flex flex-column justify-content-between"
                    >
                      <div>
                        <Card.Title className="fw-bold fs-5 mb-2">
                          {project.title}
                        </Card.Title>
                        <Card.Text
                          className="text-muted"
                          style={{ textAlign: "justify", fontSize: "14px" }}
                        >
                          {project.description.length > 100
                            ? `${project.description.slice(0, 110)}...`
                            : project.description}
                        </Card.Text>
                      </div>
                      <div className="d-flex justify-content-between align-items-baseline mt-3">
                        <Button
                          variant="link"
                          className="p-0 text-dark fw-semibold d-flex align-items-center gap-1"
                        >
                          Know more <ArrowRight />
                        </Button>
                      </div>
                    </Col>

                    {/* Image Column (for md and above only) */}
                    <Col md={5} className="d-none d-md-block">
                      <Card.Img
                        src={project.image}
                        alt={project.title}
                        className="img-fluid rounded-end-4"
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                        }}
                      />
                    </Col>
                  </Row>
                </Card>
              </Col>
            ))}
          </Row>
        </Col>
      </Row>
    </Container>
  );
};

export default Works;
